module.exports = __webpack_public_path__ + "img/vignettes-asso_0012_asmae.85adf050.jpg";